module.exports = __webpack_public_path__ + "img/atrapalo.7d1c7a05.png";